exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".schoolOrgDropdownSelectorContainer .selectorContainer{text-align:center;margin-bottom:1.5em}.schoolOrgDropdownSelectorContainer .selectElement{width:60%;height:2.5em;color:#444;padding:0 10px;border-radius:5px;border:1px solid #ccc;box-shadow:0 4px 4px 0 rgba(0,0,0,.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/exports/school_org_stats_selector.scss
// module id = 1302
// module chunks = 0